import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  getSeoForPath,
} from '../../utils/seo';

const upsertMeta = (key, content, isProperty = false) => {
  if (!content) return;
  const attr = isProperty ? 'property' : 'name';
  let element = document.querySelector(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const Seo = () => {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);

  useEffect(() => {
    document.title = seo.title;
    document.documentElement.lang = 'en';

    upsertMeta('description', seo.description);
    upsertMeta('keywords', seo.keywords);
    upsertMeta('robots', seo.noindex ? 'noindex, nofollow' : 'index, follow');
    upsertMeta('author', SITE_NAME);
    upsertMeta('googlebot', seo.noindex ? 'noindex, nofollow' : 'index, follow');

    upsertLink('canonical', seo.canonical);

    upsertMeta('og:type', 'website', true);
    upsertMeta('og:site_name', SITE_NAME, true);
    upsertMeta('og:url', seo.canonical, true);
    upsertMeta('og:title', seo.title, true);
    upsertMeta('og:description', seo.description, true);
    upsertMeta('og:image', DEFAULT_OG_IMAGE, true);
    upsertMeta('og:locale', 'en_US', true);

    upsertMeta('twitter:card', 'summary_large_image');
    upsertMeta('twitter:title', seo.title);
    upsertMeta('twitter:description', seo.description);
    upsertMeta('twitter:image', DEFAULT_OG_IMAGE);
  }, [seo]);

  return null;
};

export default Seo;
